import React from 'react'
import {BsTwitter, BsInstagram} from 'react-icons/bs'
import {AiFillLinkedin} from 'react-icons/ai'

const SocialMedia = () => {
  return (
    <div className='app__social'>
      <div>
         <a href="https://instagram.com/_chandvani?igshid=MzNlNGNkZWQ4Mg=="><BsInstagram/></a>
      </div>
      <div>
      <a href="https://www.linkedin.com/in/harshika-chandvani-83a6b5202"><AiFillLinkedin/></a>
      </div>
      <div>
      <a href=""><BsTwitter/></a>
      </div>
    </div>
  )
}

export default SocialMedia
